<template>
    <a href="/" aria-title="John Diva" class="logo">
        <img :src="logoPath" alt="john-diva-logo-2x" width="520" height="370" />
    </a>    
</template>
<script>
export default {
    name: "LogoComponent",
    data: function(){
        return {
        }
    },
    mixins:  [],
    computed:{
        logoPath: function(){
            return "https://"+this.globalHost+'/wp-content/themes/divalovers/snippets/logo/john-diva-logo-2x.png';
        }
    }
    //props:['']
}
</script>
